import styled, { keyframes } from 'styled-components'
import { PROGRESS_AREA_HEIGHT } from '~/app/components/Header'
import {
  ANATOMY_COMPACT,
  anatomyCompact,
} from '~/pages/anatomy/libs/responsive'
import {
  anatomyContainerCss,
  anatomyRootCss,
} from '~/pages/anatomy/libs/styles'
import { Button } from '~/shared/components/Button'
import { Container } from '~/shared/components/Container'
import { COLORS } from '~/shared/constants/uiConstants'

const drawCurve = keyframes`
  from { stroke-dashoffset: 1; }
  to   { stroke-dashoffset: 0; }
`

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`

export const Styles = {
  Root: styled.div`
    ${anatomyRootCss}
  `,

  StyledContainer: styled(Container)`
    ${anatomyContainerCss}
    padding: 24px 16px;
    margin-top: ${PROGRESS_AREA_HEIGHT}px;
    height: calc(100% - ${PROGRESS_AREA_HEIGHT}px);
  `,

  Title: styled.h1`
    font-size: 22px;
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 16px;
    color: ${COLORS.BLACK};
    text-align: start;

    ${anatomyCompact} {
      font-size: ${ANATOMY_COMPACT.fontSize.f22};
    }
  `,

  ChartCard: styled.div`
    background: ${COLORS.WHITE};
    border-radius: 20px;
    padding: 50px 30px 40px 40px;
    margin-bottom: 12px;
  `,

  InfoSection: styled.div`
    display: flex;
    flex-direction: column;
    color: #787b7c;
    font-size: 14px;
    margin-bottom: 16px;
  `,

  StyledButton: styled(Button)`
    margin-top: auto;
  `,

  AnimatedPath: styled.path`
    stroke-dasharray: 1;
    stroke-dashoffset: 1;
    animation: ${drawCurve} 1.5s ease-out forwards;
  `,

  HabitFormedGroup: styled.g`
    opacity: 0;
    animation: ${fadeIn} 0.3s ease-out 1s forwards;
  `,

  LessonsGroup: styled.g`
    opacity: 0;
    animation: ${fadeIn} 0.3s ease-out 1.3s forwards;
  `,
} as const
